const o = "_button_9ff2o_25", t = "_action_9ff2o_71", _ = "_loader_9ff2o_71", n = "_unset_9ff2o_80", c = "_arrow_9ff2o_85", f = "_content_9ff2o_98", r = "_flexible_9ff2o_101", e = "_md_9ff2o_109", s = "_secondary_9ff2o_117", a = "_primary_9ff2o_126", i = "_critical_9ff2o_135", l = {
  button: o,
  action: t,
  loader: _,
  unset: n,
  arrow: c,
  content: f,
  flexible: r,
  md: e,
  secondary: s,
  primary: a,
  critical: i
};
export {
  t as action,
  c as arrow,
  o as button,
  f as content,
  i as critical,
  l as default,
  r as flexible,
  _ as loader,
  e as md,
  a as primary,
  s as secondary,
  n as unset
};
//# sourceMappingURL=button.module.less.js.map
